
export const types = {
    authLogin: '[AUT] Login ',
    authLogout: '[AUT] Logout',

    addNewTodo: '[TODO] New todo',
    activeTodo: '[TODO] Set active todo',
    desativeTodo: '[TODO] Remove active todo',
    loadAllTodo: '[TODO] Set load todo',
    loadCompleteTodo: '[TODO] Set load complete todo',
    loadActiveTodo: '[TODO] Set load active todo',
    clearCompleteTodo: '[TODO] Clear complete',
    deleteTodo: '[TODO] Delete todo',
    typeFilter: '[TODO] Type Filter'
}